// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"180":"App","214":"views-error","475":"views","957":"views-app"}[chunkId] || chunkId) + "." + {"180":"1c6cad9b","214":"981e8e4b","475":"51194a64","527":"7900cde7","577":"958d9d16","583":"a43638ba","738":"a3f40239","957":"e8bb61ae","983":"29e537e4"}[chunkId] + ".chunk.js";
};